/**
 * Characters a typed backslash sequence stands for. Anything else, such as
 * `\q`, is left as the guest wrote it.
 */
const ESCAPES = {
  n: "\n",
  r: "\r",
  t: "\t",
  b: "\b",
  f: "\f",
  v: "\v",
  "\\": "\\",
  "'": "'",
  '"': '"',
  "/": "/",
};

const fromHex = (digits) => String.fromCharCode(Number.parseInt(digits, 16));

/**
 * Turns escape sequences a guest typed (`\n`, `\t`, `\\`, `\u00A0`, `\x41`)
 * into the characters they mean. Unknown sequences stay unchanged so a
 * stray backslash is not swallowed.
 */
export const interpretEscapes = (value) => {
  if (value == null) return "";
  const text = String(value);
  if (!text.includes("\\")) return text;

  return text.replace(
    /\\(?:u([0-9a-fA-F]{4})|x([0-9a-fA-F]{2})|(.))/g,
    (match, unicode, hex, simple) => {
      if (unicode) return fromHex(unicode);
      if (hex) return fromHex(hex);
      if (simple != null && Object.prototype.hasOwnProperty.call(ESCAPES, simple)) {
        return ESCAPES[simple];
      }
      return match;
    },
  );
};
